import { render, staticRenderFns } from "./NotesTable.vue?vue&type=template&id=fba29edc&scoped=true&"
import script from "./NotesTable.vue?vue&type=script&lang=js&"
export * from "./NotesTable.vue?vue&type=script&lang=js&"
import style0 from "./NotesTable.vue?vue&type=style&index=0&id=fba29edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba29edc",
  null
  
)

export default component.exports